import { filter } from "rxjs/operators";
import { SharedService } from "./../../services/shared.service";
import { ConfigService } from "src/app/services/config.service";
import { SelectStatementDateComponent } from "./../select-statement-date/select-statement-date.component";
import { ApiService } from "src/app/services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { GridsterService } from "./../../services/gridster.service";
import { FavService } from "./../../services/fav.service";
import { OrderBuyComponent } from "./../order-buy/order-buy.component";
import { AccountService } from "src/app/services/account.service";
import { CompanyList } from "src/app/models/company-list";
import { Component, Inject, OnInit } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { NavigationEnd, Router } from "@angular/router";
import { SelectCompanyModalComponent } from "../select-company-modal/select-company-modal.component";
import { StatementComponent } from "src/app/screens/user-profile/statement/statement.component";
import { SettingsComponent } from "../settings-modal/settings.component";
import { UrlConstants } from "src/app/models/urlConstants";
import { FlexLayoutService } from "src/app/services/flex-layout.service";
import { SystemSettingsService } from "src/app/services/systemSettings.service";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DeviceDetectorService } from "src/app/services/DeviceDetectorService";
import Swal from "sweetalert2";



@Component({
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent implements OnInit {
  userName: string;
  toggleBool: boolean;
  records: any = [];
  companies: CompanyList[];
  elem;
  isFullscreen: boolean = false;
  favCompanies: CompanyList[];
  favCompaniesSymbols: string[] = [];
  searchValue;
  dashboard: any;
  hasTechnicalAnalysis: boolean = UrlConstants.hasTechnicalAnalysis;
  hasFundmentalAnalysis: boolean = UrlConstants.hasFundmentalAnalysis;
  isMarket: boolean;
  currentUrl: string;
  isEGID = UrlConstants.isEGID;
  logoLink = UrlConstants.logoLink;
  enableIPO = UrlConstants.enableIPO;
  enableMutualFund = UrlConstants.enableMutualFund;
  isDarkTheme: boolean;
  showMenu=true;
  readonly ALLOW_IPO= "AllowIPO";
  readonly ALLOW_MUTUAL_FUND= "AllowMutualFund";
  device: any;
  titleMessage: string;
  textMessage: string;
  confirmButtonText: string;
  cancelButtonText: string;


  addWidget(name) {
    this.gridService.addGeneric(name,true);
  }

  // fetchAllMarketWatch() {
  //   this.companies = null;

  //   this._service.fetchAllMarketWatch().subscribe((res) => {
  //     this.companies = res as CompanyList;
  //   });
  // }

  ngAfterViewInit() {
    if (this.isMarket)
      this.sharedService.isDataLoaded.subscribe((res) => {
        if (res) this.companies = this.sharedService.allMarketCompanies;

        // this.orderBuy(this.companies[0], false);
      });
    else
      this._service.fetchNotMarketSymbols().subscribe((res: any) => {
        this.companies = res.filter((item) => item.ENG_NAME != null);
      });
    this.favService.favCompanies.subscribe((res) => {
      this.favCompanies = res;
    });
  }

toggleMenu() {
  this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      if (result.matches) {
        // Mobile
        this.showMenu = !this.showMenu;
      } else {
        // Desktop
        this.showMenu = !this.showMenu;
      }
    });
}


  WindowResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  }

  isFav(symbol) {
    return this.favService.isFav(symbol);
  }

  toggleFav(symbol) {
    this.favService.toggleFav(symbol,this.favService.selectedMarketWatchId);
  }

  statmentDialog() {
    const dialogRef = this.dialog.open(StatementComponent, {
      width: "700px",
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });
  }

  openTechAnalysisModal() {
    this.dialog.open(SelectCompanyModalComponent, {
      panelClass: "news-details-modal",
    });
  }

  navigateProfile(item) {
    this.searchValue = "";
    this.nav
      .navigate(["/company-profile", item.SYMBOL_CODE, item.Reuters])
      .then(() => (this.toggleBool = false));
  }
  settings() {
    const dialogRef = this.dialog.open(SettingsComponent, {
      width: "700px",
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });
  }

  orderBuy(company, isSell) {
    this.searchValue = "";

    const dialogRef = this.dialog.open(OrderBuyComponent, {
      disableClose: true,
      panelClass: "order-dialog-container",
      data: { symbol: company.SYMBOL_CODE, type: isSell },
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  credentialsSearchFilter(event: any) {
    const val = event.target.value.toLowerCase();

    if (val != "") {
      this.toggleBool = true;
    } else {
      this.toggleBool = false;
    }

    this.records = this.companies.filter(function (d) {
      return (
        d.ENG_NAME?.toLowerCase().includes(val) ||
        d.ARB_NAME?.toLowerCase().includes(val) ||
        d.Reuters?.toLowerCase().includes(val)
      );
    });
  }

  logout() {
    this.titleMessage = this.translate.currentLang == "en" ? "Confirm Logout" : "تأكيد تسجيل الخروج";
    this.textMessage = this.translate.currentLang == "en" ? "You will be logged out!" : "سوف يتم تسجيل خروجك!";
    this.confirmButtonText = this.translate.currentLang == "en" ? "Yes, log me out!" : "نعم، قم بتسجيل خروجي!";
    this.cancelButtonText = this.translate.currentLang == "en" ? "No, keep me logged in" : "لا، ابقيني مسجلاً للدخول";

    Swal.fire({
      title: this.titleMessage,
      text: this.textMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.confirmButtonText,
      cancelButtonText: this.cancelButtonText
    }).then((result) => {
      if (result.isConfirmed) {
        this._service.logOut(this.userName).subscribe(
          (res) => {
            this.accService.logout();
          },
          (err) => {
          }
        );
      }
    });
  }

  hideList() {
    this.records = [];
    this.toggleBool = false;
  }

  openFullscreen() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
    this.isFullscreen = !this.isFullscreen;
  }

  closeFullscreen() {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
    this.isFullscreen = !this.isFullscreen;
  }

  switchLang() {
    if (this.translate.currentLang == "ar") {
      this.translate.use("en");
      this.translate.setDefaultLang("en");
      this.gridService.saveLang("en");
    } else {
      this.translate.use("ar");
      this.translate.setDefaultLang("ar");
      this.gridService.saveLang("ar");
    }
    window.location.reload();
  }

  onStatementClick() {
    this.dialog.open(SelectStatementDateComponent);
  }

  constructor(
    private accService: AccountService,
    public dialog: MatDialog,
    private favService: FavService,
    public translate: TranslateService,
    @Inject(DOCUMENT) private document: any,
    private nav: Router,
    private gridService: FlexLayoutService,
    private _service: ApiService,
    private sharedService: SharedService,
    private router: Router,
    private settingsService: SystemSettingsService,
    private breakpointObserver: BreakpointObserver,
    private deviceService: DeviceDetectorService


  ) {
    this.showMenu = window.innerWidth<992? false : true; 
    this.dashboard = this.gridService.getGrid();
    this.elem = document.documentElement;
  }

  ngOnInit(): void {
    this.device = this.deviceService.getDeviceType();
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;

      this.settingsService.checkSetting(this.ALLOW_IPO).subscribe(isAllowed => {
        this.enableIPO = isAllowed;
      }, error => {
      });
      this.settingsService.checkSetting(this.ALLOW_MUTUAL_FUND).subscribe(isAllowed => {
        this.enableMutualFund = isAllowed;
      }, error => {
      });
  
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentUrl = event.url;
    });
    this.userName = sessionStorage.getItem("userName");
    this.accService.isFullMarketUser.subscribe((isMarket) => {
      this.isMarket = isMarket;
    });
  }

  get navButtonColor() {
    return UrlConstants.navButtonColor;
  }

  resetDashboard() {
    this.gridService.resetGrid();
    window.location.reload();
  }
}
